<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">PRODUCTO DATABEER</span>
        </div>
        <span class="header-text custom1">Ver tipo de cerveza DataBeer</span>
    </div>

    <div class="body">
        <form [formGroup]="signin" class="custom2">
            <mat-form-field class="input-container" appearance="outline">
                <mat-label class="label-text" [ngClass]="{'error-select': nombreError}">Nombre</mat-label>
                <input matInput placeholder="Nombre con que la entidad o sociedad mercantil está registrada legalmente" formControlName="nombre" [readonly]="true">
            </mat-form-field>
        </form>

        <mat-form-field appearance="outline" class="custom2" class="input-container2">
            <mat-label class="label-text">Cliente</mat-label>
            <input matInput type="text" value="{{nombreCliente}}" [readonly]="true">
        </mat-form-field>

        <div class="imagen-container" *ngIf="beerImg != null">
            <p><span class="label-text">Imagen: </span><span>Imagen del producto.</span></p>
            <mat-error *ngIf="showImageErrorMessage" class="marginTop10">Por favor, seleccione un archivo .jpg</mat-error>
            <img *ngIf="imageUrl" [src]="imageUrl" alt="Vista previa de imagen establecimiento" class="imagen-dispositivo">
            <img *ngIf="(beerImg != null) && !imageUrl" src={{beerDataImgPath}} alt="Vista previa de imagen producto" class="imagen-dispositivo">
        </div>
    </div>
</div>
<div class="footer"></div>

